import {BaseComponent} from '../base/component.base.js';
import template from './confirm-dialog.template.html';
import styles from './confirm-dialog.styles.css';
import {t} from '../../i18n/i18n.js';

export class ConfirmDialogComponent extends BaseComponent {
    #pendingResolve = null;

    connectedCallback() {
        this.loadTemplate(template, styles);
        const dialog = this.$('#dialog');
        const cancelBtn = this.$('#btn-cancel');

        cancelBtn.addEventListener('click', () => {
            this.#resolve(false);
            dialog.close();
        });

        // Native <dialog> close (Esc, backdrop click) — treat as cancel.
        dialog.addEventListener('close', () => {
            this.#resolve(false);
        });

        // Submitting the form (Enter on confirm button) resolves true.
        this.$('.confirm-dialog-form').addEventListener('submit', () => {
            this.#resolve(true);
        });

        // Backdrop click closes too.
        dialog.addEventListener('click', (e) => {
            if (e.target === dialog) {
                dialog.close();
            }
        });
    }

    /**
     * Opens the confirm dialog and resolves to true (confirm) or false (cancel/dismiss).
     * @param {{title: string, body: string, confirmLabel?: string, cancelLabel?: string, danger?: boolean}} options
     * @returns {Promise<boolean>}
     */
    ask(options) {
        const dialog = this.$('#dialog');
        const titleEl = this.$('#dialog-title');
        const bodyEl = this.$('#dialog-body');
        const cancelBtn = this.$('#btn-cancel');
        const confirmBtn = this.$('#btn-confirm');

        titleEl.textContent = options.title;
        bodyEl.textContent = options.body;
        cancelBtn.textContent = options.cancelLabel ?? t('global.cancel');
        confirmBtn.textContent = options.confirmLabel ?? t('global.confirm');
        dialog.classList.toggle('is-danger', Boolean(options.danger));

        // Resolve any in-flight ask() that wasn't closed (defensive — shouldn't happen).
        if (this.#pendingResolve) {
            this.#pendingResolve(false);
            this.#pendingResolve = null;
        }

        return new Promise((resolve) => {
            this.#pendingResolve = resolve;
            dialog.showModal();
            // Move focus off the confirm button so Enter doesn't accidentally confirm.
            cancelBtn.focus();
        });
    }

    #resolve(value) {
        if (this.#pendingResolve) {
            this.#pendingResolve(value);
            this.#pendingResolve = null;
        }
    }
}

customElements.define('user-confirm-dialog', ConfirmDialogComponent);
